// This sanitize the links and makes them clickable links
export const getFormattedLinks = (eventDetails) => {
    if (eventDetails?.event_bulletins_related_links === "[]")
        return "-"
    else
        // This returns the sanitized HTML formatted string by applying filter on incoming data
        return eventDetails?.event_bulletins_related_links?.replaceAll("/https:", "https:")
            ?.replaceAll("/http:", "http:")
            ?.replaceAll("href = \\", "href =")
            ?.replaceAll(/'/g, '"').replaceAll(/\["/g, '').replaceAll(/"]/g, '').replaceAll(/"/g, "")
            .replaceAll(/,/g, "")
            .replaceAll("/\\", '')
}
// This function gets the required date format
const getDaySub = (day) => {
    if (day > 3 && day < 21)
        return "th";
    switch (day % 10) {
        case 1:
            return "st";
        case 2:
            return "nd"
        case 3:
            return "rd"
        default:
            return "th"
    }
}


// get formatted date for create and modified date
export const getFormattedDate = (inputDate) => {
    let langCode = 'en-US';
    let dateFormatted = new Date(inputDate);
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
    return dateFormatted.toLocaleDateString(langCode, options);
}